import * as React from "react";
import DialogProps from "./IProps";
import { bindActionCreators } from "redux";
import "../../../assets/sass/widgets/dialog.scss";
import { connect } from "react-redux";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import { handleEnter, imagePathurl } from "../../utils/utils";

/**
 * @class DialogBox
 * @description
 * This component acts as a dialog box to show modal popups with a confirmation button.
 * @category Widgets
 */
class DialogBox extends React.Component<DialogProps> {
    constructor(props) {
        super(props);
        this.confirmChanges = this.confirmChanges.bind(this);
        this.closePopUp = this.closePopUp.bind(this);
    }

    /**
     * This will be called once you approve the changes in
     * a particular warrenty type
     */
    confirmChanges() {
        const { updateChange, value, currentOption, isFormValidationSuccess } = this.props;
        // This is a check if the form is validate or not
        // for now it will be true as no validation function/framework
        if (isFormValidationSuccess) {
            this.props.hidePopsUp();
            updateChange(value, currentOption);
        } else {
            //saveDraftFormSuccess({ payload: "Unable to save" });
        }
    }

    /**
     * This will be called once you  click on the
     * close button
     */
    closePopUp() {
        this.props.hidePopsUp();
    }

    render() {
        const { popupMessage, warningMessage, buttonText, tabIndex } = this.props;
        //image CDN_PATH
        const getimagePath = imagePathurl();
        return (
            <React.Fragment>
                <div className="modal-container" id="model-container-id">
                    <div className="pop-up-overlay" onClick={() => this.closePopUp()}></div>
                    <div className="pop-up-container desktopContainer" onClick={(e) => e.stopPropagation()}>
                        <div className="close-menu" onClick={() => this.closePopUp()}>
                            <img
                                tabIndex={tabIndex}
                                onKeyPress={handleEnter}
                                className="popup-close-icon"
                                src={`${getimagePath}close-mobile.png`}
                                alt="close"
                            />
                        </div>
                        <div className="popup-header-title">{popupMessage}</div>
                        <div className="popup-header-subtitle">{warningMessage}</div>
                        <div className="text-center">
                            <button
                                className="popup-btn"
                                type="button"
                                onClick={() => this.confirmChanges()}
                                tabIndex={tabIndex}
                                onKeyPress={handleEnter}
                            >
                                {buttonText}
                            </button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export function mapStateToProps(state) {
    return {
        formId: state.dynamicFormInfo.formId,
        warrantyId: state.dynamicFormInfo.warrantyId,
        formData: state.dynamicFormInfo.warrantyInfo,
        saveMsg: state.dynamicFormInfo.saveMsg,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(DialogBox);
